// extracted by mini-css-extract-plugin
module.exports = {"modal-dialog":"t_b5","modalDialog":"t_b5","modal-title":"t_b6","modalTitle":"t_b6","modal-subtitle":"t_b7","modalSubtitle":"t_b7"};